/**
 *
 * HomeHeroCarousel
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import 'react-multi-carousel/lib/styles.css';
import { PauseIcon } from '../images/PauseIcon';
import { PlayIcon } from '../images/PlayIcon';

const useStyles = makeStyles(theme => ({
  wrapper: {
    position: 'absolute',
    right: 32,
    bottom: 16,
    padding: 4,
    borderRadius: 4,
    '&:hover': {
      opacity: 0.8,
    },
    [theme.breakpoints.down('xs')]: {
      top: 12,
      right: 18,
      bottom: 'auto',
    },
  },
  icon: {
    width: 24, // change width of svg icon
    [theme.breakpoints.down('xs')]: {
      width: 16,
    },
    color: '#4B4B4B', // change svg stroke color
    '& svg': {
      '& rect': {
        fill: 'white', // change svg bg color
      },
    },
  },
}));

function PauseButton({ active, onClick }) {
  const classes = useStyles();
  return (
    <ButtonBase
      disableRipple
      onClick={onClick}
      className={classes.wrapper}
      aria-label="Play or Pause"
    >
      <div className={classes.icon}>
        {active ? <PlayIcon /> : <PauseIcon />}
      </div>
    </ButtonBase>
  );
}

PauseButton.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
};

export default PauseButton;
